// extracted by css-extract-rspack-plugin
export default {"cls1":"TranslationModal-cls1_S1Z","cls2":"TranslationModal-cls2_bZv TranslationModal-cls1_S1Z"};